import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { SLICE_NAMES, ACTION_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IStatusRepsonse } from "../../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export interface IUpdateSurveyFormStautsArgs {
  form_id: number;
  status?: number;
  editable?: number;
}

// Async Thunk for toggling form status
export const updateSurveyFormStatusThunk = createServiceAsyncThunk<
  IStatusRepsonse,
  IUpdateSurveyFormStautsArgs
>(
  ACTION_NAMES.UPDATE_SURVEY_FORM_STATUS,
  (formTogglepayload) =>
    surveyFormsService.updateSurveyFormStatus(formTogglepayload),
  ERROR_MESSAGES.UPDATE_SURVEY_FORM_STATUS_FAILURE
);

const updateSurveyFormSlice = createGenericSlice<
  IStatusRepsonse,
  IUpdateSurveyFormStautsArgs
>(SLICE_NAMES.UPDATE_SURVEY_FORM_STATUS_SLICE, updateSurveyFormStatusThunk);

export const {
  clearError: clearUpdateSurveyFormStatusError,
  clearSuccessMessage: clearUpdateSurveyFormStatusSuccess,
} = updateSurveyFormSlice.actions;

export default updateSurveyFormSlice.reducer;
